import dayjs from 'dayjs';

function getValidDateTimeLocal( dateValue ) {
    // Si ya está en formato correcto, lo retorna
    if ( typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test( dateValue ) ) {
        return dateValue;
    }
    // Si es solo fecha, la convierte a formato local
    if ( typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test( dateValue ) ) {
        return dayjs( dateValue ).format( 'YYYY-MM-DDTHH:mm' );
    }
    // Si no hay valor, retorna el valor actual
    return util.getTodayDateTimeLocal();
}
import React, { Fragment, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import util from "../../../../utils/miniUtils";
import { ADD_INVENTORY, REMOVE_INVENTORY } from "../../../../utils/constants";
import { faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';


export default function ModifyInventory( { show, handleClose, products = [], reloadData, inventoryAction = ADD_INVENTORY } ) {
    const MySwal = withReactContent( Swal );

    const [productsLocal, setProductsLocal] = useState( products );
    const [errors, setErrors] = useState( {
        showErrorAlert: false
    } );

    // Show SweetAlert2 dialog when errors.showErrorAlert is true
    useEffect( () => {
        if ( errors.showErrorAlert ) {
            MySwal.fire( {
                icon: 'warning',
                title: 'No puedes remover más productos de los existentes',
                html: `<div class=""><p>Producto: ${errors.prod?.article || ''}</p><p>En Existencia: ${errors.stored || ''}</p><p>De Baja: ${errors.newStored || ''}</p></div>`,
                confirmButtonText: 'Ok',
                customClass: {
                    confirmButton: 'btn btn-warning'
                },
                buttonsStyling: false
            } ).then( () => {
                setErrors( { ...errors, showErrorAlert: false } );
            } );
        }
    }, [ errors.showErrorAlert ] );
    const [loading, setLoading] = useState( false );
    const startLoading = () => setLoading( true );
    const stopLoading = () => setLoading( false );

    useEffect( () => {
        const loadTotals = async () => {
            try {
                const ids = products;
                const resp = await util.axios.post( `product/data/totals`, { ids } );
                const data = resp.data?.data || [];
                const a = data.map( d => ( { ...d, qty: "", date: util.getTodayDateDbFormat } ) );
                setProductsLocal( a );
            } catch ( e ) {
                util.handleError( e );
                setProductsLocal( [] );
            }
        };
        
        if ( show && Array.isArray( products ) && products.length > 0 && products.every( p => typeof p === 'number' ) ) {
            // products are IDs: fetch current totals
            loadTotals();
        } else {
            // products are full objects: keep previous behavior
            let a = JSON.parse( JSON.stringify( products ) );
            for ( let i = 0; i < a.length; i++ ) {
                a[ i ].qty = "";
                a[ i ].date = util.getTodayDateDbFormat;
                // derive currentQty when provided as full product
                if ( typeof a[ i ].currentQty === 'undefined' && typeof a[ i ].qty === 'number' ) {
                    a[ i ].currentQty = a[ i ].qty;
                }
            }
            setProductsLocal( a );
        }
    }, [ show, products, inventoryAction ] );

    const onChangeValues = ( e, index ) => {
        let { name, value } = e.target;
        // if ( value === "" ) value = 1;
        let t = [...productsLocal];
        t[index][name] = value;
        setProductsLocal( Object.assign( [], t ) );
    };

    const saveChangesOnInventory = async () => {
        try {
            startLoading();
            let response;
            let isValid = true;
            if ( inventoryAction === ADD_INVENTORY ){
                response = await util.axios.post( `inventory/data/add/`, { addInventory: productsLocal } );
            }else{
                // Validate user can remove more products that he has
                for ( let i = 0; i < productsLocal.length; i++ ) {
                    const current = parseInt( productsLocal[ i ].currentQty || 0 );
                    const toRemove = parseInt( productsLocal[ i ].qty || 0 );
                    if ( toRemove > current ){
                        setErrors( {
                            ...errors,
                            showErrorAlert: true,
                            stored: current,
                            newStored: productsLocal[ i ].qty,
                            prod: productsLocal[ i ]
                        } );
                        isValid = false;
                        break;
                    }
                }
                if ( !isValid ) {
                    stopLoading();
                    return false;
                }
                response = await util.axios.post( `inventory/data/remove/`, { removeInventory: productsLocal } );
            }

            if ( inventoryAction === REMOVE_INVENTORY && !isValid ) return;

            const { error, msg } = response["data"];
            if ( error ) throw new Error( msg );
            stopLoading();
            await reloadData();
            util.toast().success( msg );
            handleClose();
        } catch ( e ) {
            stopLoading();
            util.handleError( e );
        }
    };

    return (
        <Fragment>
            <Modal size={"lg"} show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{inventoryAction === ADD_INVENTORY ? "Agregar": "Remover de" } Inventario de Productos</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {
                        productsLocal.length > 0 ?
                            <Fragment>
                                <div className="alert alert-info mb-3">
                                    <strong>Nota:</strong> Este movimiento se registrará en el local de cada producto.
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-responsive">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Categoría</th>
                                                <th>Articulo</th>
                                                <th>Cant. Actual</th>
                                                <th>Cantidad</th>
                                                <th>Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                productsLocal.map( ( p,i ) => {
                                                    return (
                                                        <Fragment key={i}>
                                                            <tr>
                                                                <td className="align-middle">{util.zeroPad( p.id , 5 )}</td>
                                                                <td className="align-middle">{p.article}</td>
                                                                <td className="align-middle">{p.categoryName}</td>
                                                                <td className="text-center align-middle">{typeof p.currentQty !== 'undefined' ? p.currentQty : products[i]?.qty}</td>
                                                                <td width={100}>
                                                                    <input
                                                                        onChange={( e )=> onChangeValues( e, i )}
                                                                        type="number"
                                                                        name="qty"
                                                                        value={p.qty ? p.qty: ""}
                                                                        className="form-control"
                                                                    />
                                                                    <small className="text-muted">Máx: {typeof p.currentQty !== 'undefined' ? p.currentQty : products[i]?.qty || 0}</small>
                                                                </td>
                                                                <td width={100}>
                                                                    <input
                                                                        onChange={( e )=> onChangeValues( e, i )}
                                                                        type="datetime-local"
                                                                        name="date"
                                                                        value={getValidDateTimeLocal( p.date )}
                                                                        className="form-control"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    );
                                                } )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Fragment>
                            :
                            null
                    }

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm" onClick={handleClose}>
                        Cancelar
                    </button>
                    {
                        inventoryAction === ADD_INVENTORY ?
                            <button className="btn btn-sm btn-success" onClick={saveChangesOnInventory}>
                                <FontAwesomeIcon icon={faPlusCircle}/>
                                <span className="p-2">
                                    Agregar a Inventario
                                </span>
                            </button>
                            :
                            <button className="btn btn-sm btn-warning" onClick={saveChangesOnInventory}>
                                <FontAwesomeIcon icon={faMinusCircle}/>
                                <span className="p-2">
                                    Remover de Inventario
                                </span>
                            </button>

                    }

                </Modal.Footer>
            </Modal>

            {/* SweetAlert2 dialog handled by useEffect for errors.showErrorAlert */}

            {util.LOADING_SCREEN( loading )}
        </Fragment>
    );
}